import React from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "@sscs/ui";
import { ApprovalDialogFormData, RevokeFormData } from "./types";

type EditReasonProps = {
  selection: string[];
};

const Reason = ({ selection }: EditReasonProps): React.JSX.Element => {
  const formMethods = useFormContext<ApprovalDialogFormData | RevokeFormData>();
  const { formState, setValue } = formMethods;

  return (
    <>
      <Form.RadioGroup
        label="Reason"
        id="predefined-reasons"
        name="reason"
        orientation="vertical"
        items={selection.map((reason, index) => ({
          id: `reason-${index}`,
          value: reason,
          label: reason,
        }))}
        onChange={(event) => setValue("reason", event.target.value)}
        isRequired
      />
      <Form.TextArea
        placeholder="Choose a predefined reason or define your own custom reason"
        name="reason"
        id="custom-reason"
        errors={formState.errors}
        isFullWidth
        minRows={3}
      />
    </>
  );
};

export default Reason;
